import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, availableLanguages } from "@/i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    return localStorage.getItem("useko_lang") || "tr";
  });

  useEffect(() => {
    localStorage.setItem("useko_lang", lang);
    const t = translations[lang] || translations.tr;
    document.documentElement.setAttribute("lang", lang);
    document.documentElement.setAttribute("dir", t.dir || "ltr");
  }, [lang]);

  const t = translations[lang] || translations.tr;

  const value = {
    lang,
    setLang,
    t,
    languages: availableLanguages,
    isRTL: (translations[lang]?.dir || "ltr") === "rtl",
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
}

// Pick a localized field from a document like { title_tr, title_en, title_ar }
export function pick(doc, base, lang) {
  if (!doc) return "";
  return doc[`${base}_${lang}`] || doc[`${base}_tr`] || doc[base] || "";
}
